import React from "react";
import "./Sidebar.css";
import TransactionList from "./TransactionList";

interface SidebarProps {
  isOpen: boolean;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen }) => {
  return (
    <aside className={`sidebar ${isOpen ? "open" : "closed"}`}>
      <h2>Transactions</h2>
      <TransactionList />
    </aside>
  );
};

export default Sidebar;